import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Field } from 'redux-form/immutable'

import { LOCALE_PREFIX, WEEKLY_DEFINITIONS } from './constants'

import './style.scss'

@injectIntl
export default class SendingFrequencySubComponent extends Component {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        sendingFrequency: PropTypes.string.isRequired,
    }

    render() {
        const {
            sendingFrequency,
            intl: { formatMessage },
        } = this.props

        switch (sendingFrequency) {
            case 'no': {
                return (
                    <div className={'frequency-sub-component'}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.noText`}
                            values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                        />
                    </div>
                )
            }

            case 'daily': {
                return (
                    <div className={'frequency-sub-component'}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.dailyText`}
                            values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                        />
                    </div>
                )
            }

            case 'weekly': {
                return (
                    <div className={'frequency-sub-component'}>
                        <Field
                            name={'sendingWFrequencySelection'}
                            component={({ input }) => (
                                <div className={'frequency-selection-wrap'}>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.weeklyText1`} />
                                    <select {...input} className={'frequency-selection'}>
                                        {WEEKLY_DEFINITIONS.map(({ value, label }, key) => (
                                            <option key={`weekly-definition-element-${key}`} value={value} name={label}>
                                                {formatMessage({ id: `${LOCALE_PREFIX}.${label}` })}
                                            </option>
                                        ))}
                                    </select>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.weeklyText2`} />
                                </div>
                            )}
                        />
                    </div>
                )
            }

            case 'monthly': {
                return (
                    <div className={'frequency-sub-component'}>
                        <Field
                            name={'sendingMFrequencySelection'}
                            component={({ input }) => (
                                <div className={'frequency-selection-wrap'}>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.monthlyText1`} />
                                    <select {...input} className={'frequency-selection'}>
                                        {_.map(Array(30), (v, i) => i + 1).map((day, key) => (
                                            <option
                                                key={`day-selection-element-${key}`}
                                                name="day"
                                                value={day < 9 ? `0${day}` : `${day}`}
                                            >
                                                {day}.
                                            </option>
                                        ))}
                                    </select>
                                    <FormattedMessage
                                        id={`${LOCALE_PREFIX}.monthlyText2`}
                                        values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                                    />
                                    <div className={'monthly-warning'}>
                                        <FormattedMessage
                                            id={`${LOCALE_PREFIX}.monthlyWarning`}
                                            values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                                        />
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                )
            }

            default:
                return null
        }
    }
}
